export const RequiredAsterisk = () => {
  return (
    <em className="required-asterisk">*</em>
  );
};